import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import Login from './sanctum/pages/Login';
import Setup from './sanctum/pages/Setup';
import Dashboard from './sanctum/pages/Dashboard';
import DashboardHome from './sanctum/pages/DashboardHome';
import Admins from './sanctum/pages/Admins';
import Waitlist from './sanctum/pages/Waitlist';
import Users from './sanctum/pages/Users';
import { AuthProvider } from './sanctum/contexts/AuthContext';
import ProtectedRoute from './sanctum/components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/sanctum/login" element={<Login />} />
          <Route path="/sanctum/setup" element={<Setup />} />
          <Route path="/sanctum" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}>
            <Route index element={<DashboardHome />} />
            <Route path="admins" element={<Admins />} />
            <Route path="waitlist" element={<Waitlist />} />
            <Route path="users" element={<Users />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;